import { render, staticRenderFns } from "./newsMore.vue?vue&type=template&id=404bc69f&scoped=true&"
import script from "./newsMore.vue?vue&type=script&lang=js&"
export * from "./newsMore.vue?vue&type=script&lang=js&"
import style0 from "./newsMore.vue?vue&type=style&index=0&id=404bc69f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404bc69f",
  null
  
)

export default component.exports